export default __webpack_public_path__ + "static/media/birchmount.3bb65dbc.png";